import { getSegmentConfig } from './segmentConfigs';

export const Configs = {
  getSegmentConfig,
};
